<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    科学馆站<br>
站点介绍<br>
科学馆站位于福田区上步路与松岭路之间的深南中路上，车站周边有华联大厦、科技大厦；老干部活动中心、商业银行大厦和城市中心广场。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:15	00:00	1号线	2分钟	4分40秒<br>
机场东	06:28	23:08	1号线	2分钟	4分40秒<br>
科学馆	--	--	6号线	3分24秒	6分20秒<br>
松岗	06:20	23:00	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:16	23:58	1号线	3分45秒	5分45秒<br>
机场东	06:28	23:08	1号线	3分45秒	5分45秒<br>
科学馆	--	--	6号线	4分45秒	6分钟<br>
松岗	06:20	23:00	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:16	00:58	1号线	3分45秒	5分45秒<br>
机场东	06:28	00:08	1号线	3分45秒	5分45秒<br>
科学馆	--	--	6号线	4分45秒	6分钟<br>
松岗	06:20	00:00	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南中路北侧（东）、上步中路、中国共产党深圳市委员会、市政协、深圳市总工会、市府二办、深圳市老干部活动中心、深圳市统计局、深圳博物馆、深圳市第二人民医院中西医结合分院、深圳会堂、深圳安利体验馆、深圳市科学馆、深勘大厦<br><br>
B出入口:<br>
深南中路北侧（西）、燕南路、振兴路、深圳市住房和建设局、华联大厦、设计大厦、机场巴士、CICCIMAll购物中心<br><br>
C出入口:<br>
深南中路南侧（西）、松岭路、上步中学、深圳市中医肛肠医院、南园派出所<br><br>
D出入口:<br>
深南中路南侧（东）上步南路、滨河路、东园路、巴丁街、档案大厦、上步小学、台湾花园、国企大厦、新城市广场<br><br>
E出入口:<br>
深南中路南侧，上步南路西侧，南园路北侧（西）<br><br>
F出入口:<br>
南园路北侧（东），上步南路东侧，深南中路南侧<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 市总工会<br>
4、8、12、202、M132、N17、高峰专线29<br><br>
B出入口:<br>
公交站名： 兴华宾馆东<br>
3、113、202、203、M133、M191、N3、N4、高快巴士60<br><br>
C出入口:<br>
公交站名： 兴华宾馆东<br>
3、113、203、M133、M191、M383、N3、N4、高快巴士60<br><br>
E出入口:<br>
公交站名： 爱华市场公交站<br>
23、29、B930<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>